/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { pendingSyncStateLastFailureDtoSchema } from "./pendingSyncStateLastFailureDtoSchema";
import { z } from "zod/v4";

export const pendingSyncStateDtoSchema = z.object({
    "type": z.string(),
"provider": z.string(),
"toFetch": z.string().describe("Capped at \"3000+\" when the count exceeds 3000"),
"toProcess": z.string(),
get "lastFailure"(){
                return pendingSyncStateLastFailureDtoSchema.nullish()
              },
"updatedAt": z.iso.datetime()
    })